// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"5cde194c","356":"38535d8f"}[chunkId] + ".chunk.css";
};